import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle2, Mail, ShieldCheck } from 'lucide-react';

export default function AccountDeletion() {
  const subject = encodeURIComponent('Kontolöschung Make It Booking');
  const body = encodeURIComponent('Hallo Make It Booking Team,\n\nich möchte die Löschung meines Kontos beantragen.\n\nE-Mail des Kontos:\nName der Organisation:\nGewünschter Umfang: Benutzerkonto / gesamte Organisation\n');

  return (
    <main className="min-h-screen bg-[#F5F5F7] px-4 py-10 text-[#1D1D1F] sm:px-6">
      <div className="mx-auto max-w-3xl">
        <Link to="/" className="mb-6 inline-flex items-center gap-2 text-sm font-medium hover:underline">
          <ArrowLeft className="h-4 w-4" /> Zurück zu Make It Booking
        </Link>
        <section className="rounded-3xl border border-[#E5E5EA] bg-white p-6 shadow-sm sm:p-10">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#F5F5F7]">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <h1 className="mt-5 text-3xl font-semibold tracking-tight">Konto und Daten löschen lassen</h1>
          <p className="mt-3 text-base leading-7 text-[#6B7280]">
            Du kannst die Löschung deines persönlichen Zugangs oder als Organisationsinhaber die Löschung der gesamten Organisation beantragen.
          </p>

          <div className="mt-8 space-y-4">
            {[
              'Öffne in der mobilen App Einstellungen und wähle Kontolöschung beantragen.',
              'Alternativ kannst du die Anfrage über die unten angegebene E-Mail-Adresse senden.',
              'Wir prüfen deine Identität, aktive Verträge und gesetzliche Aufbewahrungspflichten und melden uns an deine hinterlegte E-Mail-Adresse.',
            ].map((text) => (
              <div key={text} className="flex items-start gap-3 rounded-2xl bg-[#F5F5F7] p-4">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-[#1F6B35]" />
                <p className="text-sm leading-6">{text}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-[#E5E5EA] p-5">
            <h2 className="font-semibold">Wichtiger Hinweis</h2>
            <p className="mt-2 text-sm leading-6 text-[#6B7280]">
              Patienten-, Behandlungs- und Abrechnungsdaten können gesetzlichen Aufbewahrungspflichten unterliegen. Solche Daten werden nach Prüfung gelöscht oder bis zum Ablauf der jeweiligen Frist gesperrt und anschließend gelöscht. Die Anfrage beendet ein kostenpflichtiges Abonnement nicht automatisch, bis die Vertragsprüfung abgeschlossen ist.
            </p>
          </div>

          <a
            href={`mailto:hello@makeit-media.de?subject=${subject}&body=${body}`}
            className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full bg-black px-5 py-3.5 font-semibold text-white sm:w-auto"
          >
            <Mail className="h-5 w-5" /> Löschung per E-Mail beantragen
          </a>
        </section>
      </div>
    </main>
  );
}
